import Modal from "../../molecules/Modal"
import styles from "./index.module.scss"
import intl from "react-intl-universal"
import RcmpActivityField from "../ActivityField"
import { FormProvider, useForm } from "react-hook-form"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import { Typography } from "@stardust-ds/react"
import PurePlusIcon from "../../../assets/icons/PurePlusIcon"
import TrashIcon from "../../../assets/icons/TrashIcon"
import { useContext, useEffect, useRef, useState } from "react"
import Button from "../../atoms/Button"
import RcmpModalCustomFields from "../ModalCustomFields"
import RcmpModalCreateNewCustomField from "../../molecules/ModalCreateNewCustomField"
import useDataApi from "../../../hooks/useDataApi"
import {
  fnCreateActivityField,
  fnUpdateField as fnUpdateFields,
} from "../../../services/activityFields"
import { fnShowTutorial, fnUpdateShowTutorial } from "../../../services/models"
import Radios from "../../molecules/Radios"
import BoardContext from "../../../contexts/Board"
import {
  cStatusSlug,
  dConclusionDateSlug,
  dCreationDateSlug,
} from "../../../constans/activity-slugs"
import RcmpTutorialModal from "../TutorialModal/index"
import RcmpModalInfo from "../ModalInfo"
import Tabs from "../../molecules/Tabs"
import ClockRotateIcon from "../../../assets/icons/ClockRotateIcon"
import EditIcon from "../../../assets/icons/EditIcon"
import RcmpHistory from "../../molecules/History"

function RcmpFieldsRow(props) {
  const { field, index, fnDeleteField, fnSetAFields, aFields, bIsForm } = props

  const aRadiosValues = [
    {
      label: intl.get("activityModelModal.not_required"),
      name: `fieldModelIsRequired-${index}`,
      value: `NOT_REQUIRED`,
      checked: true,
      id: field.opfd_nid,
    },
    {
      label: intl.get("activityModelModal.required_for_completion"),
      name: `fieldModelIsRequired-${index}`,
      value: `TO_CONCLUDE`,
      checked: false,
      id: field.opfd_nid,
    },
    {
      label: intl.get("activityModelModal.required_for_creation"),
      name: `fieldModelIsRequired-${index}`,
      value: `TO_CREATE`,
      id: field.opfd_nid,
    },
  ]
  const [aRadioSelect, fnSetARadioSelect] = useState(aRadiosValues)

  useEffect(() => {
    aFields.map((oField) => {
      if (
        oField.ombf_opfd_nid === field.ombf_opfd_nid ||
        oField.opfd_cslug === field.opfd_cslug
      ) {
        return {
          ...oField,
          ombf_brequired: oField.ombf_brequired,
        }
      }
      return oField
    })
    const updatedRadios = aRadiosValues.map((radio) => ({
      ...radio,
      checked: radio.value === field.ombf_brequired,
    }))

    fnSetARadioSelect(updatedRadios)
  }, [aFields])
  function fnHandleRadioValue(value, field) {
    const updatedRadios = aRadiosValues.map((radio) => {
      return {
        ...radio,
        checked: radio.value === value,
      }
    })
    const newFields = aFields.map((oField) => {
      if (oField.opfd_nid === field.opfd_nid) {
        return {
          ...oField,
          ombf_brequired: value,
        }
      } else {
        return oField
      }
    })
    fnSetAFields(newFields)
    fnSetARadioSelect(updatedRadios)
  }

  function fnDeleteRow(i, e) {
    e.stopPropagation()
    fnDeleteField(i)
    return
  }
  return (
    <Draggable draggableId={`modelActivityField-${index}`} index={index}>
      {(provided, snapshot) => {
        if (
          provided.draggableProps.style &&
          "top" in provided.draggableProps.style &&
          "left" in provided.draggableProps.style
        ) {
          provided.draggableProps.style.left -= 70 // fine tuning for left postion
          provided.draggableProps.style.top -= 70 // fine tuning for top postion
        }
        return (
          <div
            className={styles.rowField}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <div className={styles.field}>
              <div className={styles.field}>
                <RcmpActivityField
                  {...field}
                  opfd_cname={field?.opfd_cname}
                  ombf_bautofill={field?.ombf_bautofill}
                  opfd_cslug={field?.opfd_cslug}
                  opfd_ctype={field?.opfd_ctype}
                  opfd_nid={field?.opfd_nid}
                  bIsDraggable={true}
                  bIsDisabled={true}
                  bIsEditModel={true}
                  aFields={aFields}
                />
              </div>
              {field?.opfd_cslug !== cStatusSlug && (
                <div
                  className={styles.trashIconArea}
                  onClick={(e) => fnDeleteRow(index, e)}
                >
                  <TrashIcon fill={"#737D86"} height={24} width={24} />
                </div>
              )}
            </div>

            {![dConclusionDateSlug, dCreationDateSlug, cStatusSlug].includes(
              field.opfd_cslug,
            ) &&
              field.opfd_ctype !== "CALC" &&
              !bIsForm && (
                <div className={styles.radiosContainer}>
                  <Radios
                    radios={aRadioSelect}
                    onChange={(e) => fnHandleRadioValue(e, field)}
                  />
                </div>
              )}
          </div>
        )
      }}
    </Draggable>
  )
}

export default function RcmpModalActivityModel(props) {
  const { bIsOpen, fnOnClose, fnSubmit, fnCancel, bIsForm = false } = props
  const { oCurrentBoard, oBoardRes, fnRefreshCurrentBoard } = useContext(BoardContext)
  const [oUpdateFieldRes, fnUpdateField] = useDataApi(fnUpdateFields)

  const useFormMethods = useForm({})
  const [aFields, fnSetAFields] = useState([])
  const [aModelFields, fnSetAModelFields] = useState([])
  const [aNewFields, fnSetANewFields] = useState([])
  const [bOpenCustomField, fnSetBOpenCustomFields] = useState(false)
  const [bOpenWarningModal, fnSetBOpenWarningModal] = useState(true)
  const [bDisableButton, fnSetBDisableButton] = useState(false)
  const [bOpenModalNewCustomField, fnSetBOpenModalNewCustomField] = useState(false)
  const [bOpeEditCustomField, fnSetBOpeEditCustomField] = useState(false)
  const [oCustomField, fnSetOCustomField] = useState()
  const [bIsOpenModalInfo, fnSetBIsOpenModalInfo] = useState(false)

  const [bShowWarningModal, fnSetBShowWarningModal] = useState(true)
  const [oCreateActivityFieldRes, fnCreateActivityFielReq, fnCreateActivityFieldReset] =
    useDataApi(fnCreateActivityField)
  const [oShowTutorialRes, fnShowTutorialReq] = useDataApi(fnShowTutorial)
  const [cFieldRequired, fnSetCFieldRequired] = useDataApi("not_required")
  const [aRadioSelect, fnSetARadioSelect] = useState([])
  const [nCurrentTabSelected, fnSetCurrentTabSelected] = useState(0)
  const [bIsOpenModalAlert, fnSetBIsOpenModalAlert] = useState(false)
  const cMessageModalInfo = {
    fistParagraph: intl.get("ModalActivityModelWarning.messageFirstParagraph"),
    secondParagraph: intl.get("ModalActivityModelWarning.messageSecondParagraph"),
  }
  const aHeaders = [
    intl.get("automation_list_activities.date"),
    intl.get("automation_list_activities.users"),
    intl.get("automation_list_activities.type"),
    intl.get("automation_list_activities.change"),
  ]

  useEffect(() => {
    if (!bIsOpen) return

    const oBoardModel = oCurrentBoard?.board_model
    ? oCurrentBoard?.board_model
    : oCurrentBoard?.data[0]?.board_model
    const aBoardModelFields = oBoardModel?.fields?.map(({ field, ...rest }) => ({
      ...rest,
      ...field,
      opvf_bis_visible: true,
    })) || []

    fnSetAModelFields(aBoardModelFields)
    fnSetAFields(aBoardModelFields)

    if (aFields.length && aModelFields?.length) {
      const aNewFormatedData = aFields.map((field) => {
        const formatedField = aModelFields.find(
          (formatedField) => formatedField.opfd_nid === field.opfd_nid,
        )

        return { ...(formatedField || {}), ...field }
      })

      fnSetAFields(aNewFormatedData)
    }
  }, [oCurrentBoard, bIsOpen, oUpdateFieldRes])

  useEffect(() => {
    fnCreateActivityFieldReset()
  }, [bOpenCustomField])

  useEffect(() => {
    if (!aFields?.length) return

    const aCalcFields = aFields.filter((field) => field?.opfd_ctype === "CALC")

    if (!aCalcFields?.length) return

    const { watch } = useFormMethods

    const subscription = watch((values, { name }) => {
      const isCalcField = aCalcFields.some(
        (field) => name === `activity-field-${field.opfd_nid}`,
      )
      // update aFields array with calc fields values
      if (isCalcField) {
        const aNewFields = aFields.map((field) => {
          if (name === `activity-field-${field.opfd_nid}`) {
            return {
              ...field,
              ombf_cvalue: values[name],
            }
          }

          return field
        })

        fnSetAFields(aNewFields)
      }
    })

    return () => subscription.unsubscribe()
  }, [aFields, useFormMethods.watch])

  async function handleDragEnd(result) {
    if (!result.destination) return

    let tempData = [...aFields]
    let [fieldOrder] = tempData.splice(result.source.index, 1)
    tempData.splice(result.destination.index, 0, fieldOrder)
    const aNewPosition = tempData.map((temp, i) => ({
      ombf_opfd_nid: temp.ombf_opfd_nid ? temp.ombf_opfd_nid : temp.opfd_nid,
      ombf_bautofill: temp.ombf_bautofill || false,
      ombf_brequired: temp.ombf_brequired,
      ombf_nposition: i,
    }))
    fnSetAFields(tempData)
  }
  function fnTranslateHistoryValues(data) {
    const aRequiredTypes = {
      NOT_REQUIRED: intl.get("activityModelModal.not_required"),
      TO_CONCLUDE: intl.get("activityModelModal.required_for_completion"),
      TO_CREATE: intl.get("activityModelModal.required_for_creation"),
    }
    if (data.opht_caction === "created" && data.opht_changeable_type === "ModelBoard") {
      return intl.get("modal_automation_list.history.create_message", {
        newFunction: intl.get("BlocksPage.history_board.the_board"),
      })
    }
    switch (data.opht_caction) {
      case "created":
      case data.ModelBoardField === "ModelBoardField":
        return intl.get("BlocksPage.history_board.added_field", {
          field: data.opht_changeable_subtype_name,
        })
      case "deleted":
        return intl.get("BlocksPage.history_board.deleted_field", {
          field: data.opht_changeable_subtype_name,
        })
      case "update":
        if (data.opht_cfield === "ombf_cvalue") {
          return intl.get("modal_automation_list.history.update_message", {
            field: data.opht_changeable_subtype_name,
            oldValue: data.opht_cold_value,
            newValue: data.opht_cnew_value,
          })
        }
        return intl.get("BlocksPage.history_board.required_changed", {
          field: data.opht_changeable_subtype_name,
          oldValue: aRequiredTypes[data.opht_cold_value],
          newValue: aRequiredTypes[data.opht_cnew_value],
        })
    }
  }
  async function submitModel() {
    fnSetBDisableButton(true)
    const values = useFormMethods.getValues()
    const errors = useFormMethods.formState.errors
    const aNewPosition = aFields.map((temp, i) => ({
      ombf_opfd_nid: temp.ombf_opfd_nid ? temp.ombf_opfd_nid : temp.opfd_nid,
      ombf_bautofill: temp.ombf_bautofill || false,
      ombf_brequired: temp.ombf_brequired,
      ombf_nposition: i,
    }))
    //newObj = aNewPosition
    //transforme o objeto values em um array de objetos
    const aNewValue = Object.keys(values).map((key) => {
      const splitedName = key.split("-")
      return {
        opfd_nid: splitedName[splitedName.length - 1],
        opfv_cvalue: values[key],
      }
    })
    /* .filter((value) => value.opfv_cvalue) */
    // faça um ajuste para que pra cada item de aNewPosition que tenha o ombf_opfd_nid === a Number(value.opfd_nid) adicione o opfv_cvalue. Mantenha a ordem que já existe no array

    aNewPosition.forEach((position) => {
      const index = aNewValue.findIndex(
        (value) => Number(value.opfd_nid) === position.ombf_opfd_nid,
      )
      if (index !== -1) {
        position.ombf_cvalue = aNewValue[index].opfv_cvalue
      }
    })

    if (Object.keys(errors).length === 0) {
      await fnSubmit(
        oCurrentBoard?.board_model?.opmb_nid ||
        oCurrentBoard?.data[0]?.board_model?.opmb_nid,
        aNewPosition,
        () => {
          fnSetBDisableButton(false)
        },
      )

      fnSetBDisableButton(true)
    }
    /*  await fnSubmit(
      oCurrentBoard?.board_model?.opmb_nid ||
        oCurrentBoard?.data[0]?.board_model?.opmb_nid,
      aNewPosition,
      () => {
        fnSetBDisableButton(false)
      },
    ) */

    fnSetBDisableButton(false)
    fnSetBIsOpenModalAlert(false)
  }

  //add new fields in the model
  useEffect(() => {
    if (aNewFields.length === 0) return
    let aVisibleFields = []
    let aFieldsRemoved = aNewFields

    for (let i = aNewFields.length - 1; i >= 0; i--) {
      const oField = aNewFields[i]
      const existingFieldIndex = aVisibleFields.findIndex(
        (field) => field?.opfd_nid === oField?.opfd_nid,
      )
      //remove fields in the model
      if (oField?.bis_visible === false || oField?.bis_visible === undefined) {
        aFieldsRemoved.splice(existingFieldIndex, 1)
      }
    }

    fnSetAFields(aFieldsRemoved)
    fnSetANewFields([])
  }, [aNewFields, bIsOpen])

  useEffect(() => {
    ; (async () => {
      const response = await fnShowTutorialReq()
      fnSetBOpenWarningModal(!response.data.opsm_bvisualized)
    })()
    fnSetBDisableButton(false)
  }, [bIsOpen])

  function fnOpenModalCustonField() {
    fnOnClose()
    fnSetBOpenCustomFields(true)
  }

  function fnHandleCloseCustonFields() {
    fnSetBOpenCustomFields(false)
    fnCancel(true)
  }

  function fnConfirmCustomField(aNewFields) {
    let oTempFieldsModel = aFields
    aNewFields?.map((oSelectField, i) => {
      if (oSelectField?.bis_visible) {
        const oFieldValue = oTempFieldsModel?.find(
          (oValue) => oValue?.opfd_nid === oSelectField?.opfd_nid,
        )

        if (!oFieldValue) {
          // add new field in model
          oTempFieldsModel.push({
            ...oSelectField,
            opfv_opfd_nid: oSelectField?.opfd_nid,
            opfv_cvalue: "",
            selected_option: null,
            ombf_brequired: "NOT_REQUIRED",
          })
        }
      }
      if (!oSelectField?.bis_visible) {
        const indexToRemove = oTempFieldsModel.findIndex(
          (oValue) => oValue?.opfd_nid === oSelectField?.opfd_nid,
        )

        if (indexToRemove !== -1) {
          // remove field in model
          oTempFieldsModel.splice(indexToRemove, 1)
        }
      }
    })
    fnSetAFields(oTempFieldsModel)
    fnSetBOpenCustomFields(false)
    fnCancel(true)
  }

  async function fnCloseModalWarning() {
    if (bShowWarningModal === false) {
      await fnUpdateShowTutorial()
      return fnSetBOpenWarningModal(false)
    }
    return fnSetBOpenWarningModal(false)
  }

  function fnOpenCreateCustomField() {
    fnSetBOpenModalNewCustomField(true)
    fnSetBOpenCustomFields(false)

    // reset edit
    fnSetBOpeEditCustomField(false)
    fnSetOCustomField(null)
  }

  function fnHandleEditCustomField(oField) {
    fnSetBOpenModalNewCustomField(true)
    fnSetBOpenCustomFields(false)

    // add edit config
    fnSetBOpeEditCustomField(true)
    fnSetOCustomField(oField)
  }

  function fnCloseCreateCustomField() {
    fnSetBOpenModalNewCustomField(false)
    fnSetBOpenCustomFields(true)
  }

  function fnHandleOnSelectTab(data) {
    fnSetCurrentTabSelected(data)
  }

  async function fnSubmitNewCustomField(oData) {
    if (bOpeEditCustomField) {
      const response = await fnUpdateField(oData)
      await fnRefreshCurrentBoard()
      response.success && fnCloseCreateCustomField()
      return
    }
    const response = await fnCreateActivityFielReq(oData)
    await fnRefreshCurrentBoard()
    response.success && fnCloseCreateCustomField()
  }

  const fnHandleDeleteField = (index) => {
    const updatedFields = aFields.filter((field, i) => i !== index)
    fnSetAFields(updatedFields)
  }

  function fnHasFieldsChanges() {
    const aModelFields = oCurrentBoard.board_model?.fields || []
    return aFields.some((newField) => {
      const oOriginalField = aModelFields.find(
        (f) => f?.ombf_nid === newField?.ombf_nid,
      )

      if (!oOriginalField) {
        return true
      }

      if (
        oOriginalField?.ombf_brequired !== newField?.ombf_brequired ||
        oOriginalField?.ombf_nposition !== newField?.ombf_nposition
      ) {
        return true
      }

      return false
    })
  }

  async function fnCheckFields () {
    fnSetBDisableButton(true)
    const aModelFields = oCurrentBoard.board_model?.fields || []
    const bBoardHasAutomation = oCurrentBoard?.automation_count > 0
    let bHasDifferentParam = false
    let bWillBeDisableAutomation = false

    if (bBoardHasAutomation) {
      bWillBeDisableAutomation = aFields.some((newField) => {
        const oOriginalField = aModelFields.find(
          (f) => f?.ombf_nid === newField?.ombf_nid,
        )

        if (
          oOriginalField?.ombf_brequired !== "TO_CREATE" &&
          newField?.ombf_brequired === "TO_CREATE"
        )
          return true

        return false
      })
    }

    if (bWillBeDisableAutomation) {
      fnSetBIsOpenModalAlert(true)
      return
    }

    await submitModel()
  }

  function cancelSubmitModel() {
    fnSetBIsOpenModalAlert(false)
    fnSetBDisableButton(false)
  }

  function fnHandleOnCloseModal() {
    if (aFields?.length !== aModelFields?.length || fnHasFieldsChanges()) {
      fnSetBIsOpenModalInfo(true)
      return
    }

    fnOnClose()
  }

  return (
    <>
      <FormProvider {...useFormMethods}>
        <Modal isOpen={bIsOpen} size={"lg"}>
          <Modal.Header
            onClose={fnHandleOnCloseModal}
          >
            {intl.get("BlocksPage.custom_fields")} - {oCurrentBoard?.name}
          </Modal.Header>
          <Modal.Content>
            <div className={styles.modelActivityContainer}>
              <Tabs
                onSelect={fnHandleOnSelectTab}
                defaultIndex={0}
                selectedIndex={nCurrentTabSelected}
              >
                <Tabs.TabList className={styles.tabs}>
                  <Tabs.Tab>
                    <EditIcon width="16px" height="16px" /> {intl.get("BlocksPage.edit")}
                  </Tabs.Tab>
                  <Tabs.Tab>
                    <ClockRotateIcon /> {intl.get("BlocksPage.history")}
                  </Tabs.Tab>
                </Tabs.TabList>
                <Tabs.TabPanel>
                  <div className={styles.container}>
                    <DragDropContext onDragEnd={handleDragEnd}>
                      <Droppable direction="vertical" droppableId="modelActivityDrop">
                        {(provided, snapshot) => (
                          <div
                            className={styles.contentModal}
                            id="contentModal"
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                          >
                            <div className={styles.customFields}>
                              <PurePlusIcon fill={"#6CB6E3"} />
                              <Typography
                                type="h5"
                                color="#6CB6E3"
                                onClick={fnOpenModalCustonField}
                              >
                                {intl.get("BlocksPage.add_fields")}
                              </Typography>
                            </div>
                            <div>
                              {aFields?.map((field, i, arr) => {
                                return (
                                  <>
                                    <RcmpFieldsRow
                                      key={i}
                                      field={field}
                                      cFieldRequired={cFieldRequired}
                                      fnSetCFieldRequired={fnSetCFieldRequired}
                                      index={i}
                                      fnDeleteField={fnHandleDeleteField}
                                      fnSetAFields={fnSetAFields}
                                      aFields={aFields}
                                      fnSetARadioSelect={fnSetARadioSelect}
                                      aRadioSelect={aRadioSelect}
                                      bIsForm={bIsForm}
                                      ombf_cvalue={field.ombf_cvalue}
                                    />
                                  </>
                                )
                              })}
                            </div>
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>
                </Tabs.TabPanel>
                <Tabs.TabPanel>
                  <div className={styles.historyContainer}>
                    <RcmpHistory
                      cTargetHistoryType={"modelBoard"}
                      nTargetId={oCurrentBoard?.id}
                      aHeaders={aHeaders}
                      fnGetHistory={() => { }}
                      fnFormatTextHistory={fnTranslateHistoryValues}
                      bGetHistory={
                        JSON.stringify(aFields) === JSON.stringify(aModelFields)
                      }
                    />
                  </div>
                </Tabs.TabPanel>
              </Tabs>
            </div>
          </Modal.Content>
          <Modal.Footer>
            <div className={styles.fotterArea}>
              <Button
                variant="outline"
                onClick={() => {
                  //fnSetAFields(aFormatedData)
                  //verifica se o aFields é igual ao aModelFields
                  if (JSON.stringify(aFields) === JSON.stringify(aModelFields)) {
                    fnOnClose()
                    return
                  } else {
                    fnSetBIsOpenModalInfo(true)
                  }
                }}
              >
                {intl.get("cancel")}
              </Button>
              <Button
                onClick={async () => {
                  fnSetAModelFields(aFields)
                  fnCheckFields()
                }}
                isLoading={bDisableButton}
                disabled={aFields.length === 1}
              >
                {intl.get("save")}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </FormProvider>
      <RcmpModalCreateNewCustomField
        bIsOpen={bOpenModalNewCustomField}
        fnCancel={fnCloseCreateCustomField}
        fnHandleConfirm={fnSubmitNewCustomField}
        oCreateActivityFieldRes={oCreateActivityFieldRes}
        bIsEdit={bOpeEditCustomField}
        oField={oCustomField}
      />

      {bOpenCustomField && (
        <RcmpModalCustomFields
          bIsOpen={bOpenCustomField}
          buttonCancelText={intl.get("cancel")}
          buttonSaveText={intl.get("BlocksPage.save_changes")}
          title={intl.get("BlocksPage.add_fields")}
          fnOpenModalNewCustomField={fnOpenCreateCustomField}
          fnEditCustomField={fnHandleEditCustomField}
          textHead={intl.get("BlocksPage.custom_fields")}
          size={"lg"}
          fnHandleCancel={fnHandleCloseCustonFields}
          fnHandleConfirm={fnConfirmCustomField}
          aCheckedFields={aFields}
          bDisableDefaultFields={true}
          // fnSetUpdateFields={fnSetANewFields}
          bIsEdit={false}
        />
      )}
      <RcmpTutorialModal
        bIsOpen={bIsOpen && bOpenWarningModal}
        fnOnClose={fnCloseModalWarning}
        onChange={fnSetBShowWarningModal}
        cHeaderText={intl.get("ModalActivityModelWarning.fieldSettings")}
        cMessage={cMessageModalInfo}
      />

      <RcmpModalInfo
        bIsOpen={bIsOpenModalInfo}
        description={intl.get("modal_new_form.warning_text_form")}
        subText={intl.get("modal_new_form.warning_text_subText")}
        title={intl.get("cancel")}
        buttonCancelText={intl.get("activityModelModal.close_when_change_field_cancel")}
        buttonSaveText={intl.get("activityModelModal.close_when_change_field_sure")}
        size={"sm"}
        fnHandleConfirm={() => {
          fnSetBIsOpenModalInfo(false)
          fnSetAFields(aModelFields)
          fnOnClose()
        }}
        fnHandleCancel={() => fnSetBIsOpenModalInfo(false)}
      />
      <RcmpModalInfo
        bIsOpen={bIsOpenModalAlert}
        size={"sm"}
        description={intl.get("activityModelModal.save_when_change_field")}
        subText={intl.get("activityModelModal.save_when_change_field_message")}
        fnHandleCancel={cancelSubmitModel}
        title={intl.get("warning")}
        fnHandleConfirm={submitModel}
      />
    </>
  )
}
